import { get, post, del } from "../common/apiClient";

const PATH_DOCUMENT = "/document";

const createDocument = async (body) => {
  return await post(PATH_DOCUMENT, body);
};

const getDocuments = async (pageNumber, limit = 6, searchQuery, type) => {
  let query = `?page=${pageNumber}&limit=${limit}`;
  if (searchQuery) {
    query += `&q=${searchQuery}`;
  }
  if (type) {
    query += `&type=${type}`;
  }
  return await get(PATH_DOCUMENT + query);
};

const deleteDocument = async (documentId) => {
  return await del(PATH_DOCUMENT + `/${documentId}`);
};

const totalDocuments = async () => {
  return await get(PATH_DOCUMENT + `/total`);
};

export { createDocument, getDocuments, deleteDocument, totalDocuments };
